<template>
  <!-- applicationLight: vuetify light theme -->
  <v-app
    id="app"
    style="background-color: transparent;">
    <!-- Main -->
    <template>
      <!-- Header visible Only if !GrowthPlan -->
      <!-- <Header
        :is-embedded="isEmbedded"/> -->
      <v-layout
        class="mainContainer">

        <v-layout
          v-if="$route && $route.name"
          :class="isEmbedded ? 'mb-11' : 'd-block ' + $route.name">
          <v-container
            class="pa-0 MainRouterContainer">
            <router-view/>
          </v-container>
        </v-layout>
      </v-layout>
    </template>
    <!-- Snackbar -->
    <snackbar ref="snackbar"/>
  </v-app>
</template>

<script>

import { localeMixin } from './mixins'
import Header from './components/Header.vue'
import DashboardLoader from './components/Loader.vue'
import Snackbar from './components/snackbars/Snackbar.vue'

export default {
  name: 'App',
  components: {
    Header,
    Snackbar,
    DashboardLoader
  },
  mixins: [ localeMixin ],

  data () {
    return {
      isEmbedded: false
    }
  },

  computed: {
  },

  watch: {
    '$route' (to, from) {
      let pageName = 'Meeting Scheduler'
      if (this.$route.query && this.$route.query.embed) {
        this.isEmbedded = true
      }
      try {
        if (this.$route && this.$route.name) {
          switch (this.$route.name.toLowerCase()) {
            case 'notfound':
              pageName = '404: Page not Found'
              break
            case 'home':
              pageName = 'Gmelius meeting scheduler'
              break
            default:
              pageName = this.$route.name
          }
          pageName = pageName.replace(':', ': ').split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ')
        }
      } catch (err) {
        console.error(err)
      }
      document.title = `${pageName} - Gmelius`
    }
  }
}
</script>

<style lang="scss" scoped>
.MainRouterContainer {
  // background-image: url("/assets/default-theme.png");
  // background-repeat: no-repeat;
  // background-position: center;
  // background-size: contain;
  max-width: 1440px;

  &.Home {
    max-width: 1680px !important;
  }
}
</style>

<style lang="scss">
@import "./styles/app.scss";
html, body {
  overflow-y: auto;
}
</style>
